// Lightweight, privacy-respectful PMF funnel tracker.
// Anonymous visitor id only; no PII unless the user types their email in the survey.
import axios from "axios";
import { API } from "@/lib/api";

const KEY = "pmf_vid";
const TS = "pmf_vid_ts";
// Only attribute in-app activity to a survey visitor within this window of the tryout.
const WINDOW_MS = 12 * 60 * 60 * 1000;

function uuid() {
  try {
    if (window.crypto?.randomUUID) return window.crypto.randomUUID();
  } catch (_) {}
  return `pmf_${Date.now()}_${Math.random().toString(36).slice(2, 10)}`;
}

// Survey page: make sure a visitor id exists and (re)start the activity window.
export function ensureVisitorId() {
  let id = localStorage.getItem(KEY);
  if (!id) {
    id = uuid();
    localStorage.setItem(KEY, id);
  }
  localStorage.setItem(TS, String(Date.now()));
  return id;
}

// App side: if the user arrived from the survey ("?pmf=<id>"), adopt that id + open the window.
export function adoptFromUrl() {
  try {
    const p = new URLSearchParams(window.location.search).get("pmf");
    if (p) {
      localStorage.setItem(KEY, p.slice(0, 80));
      localStorage.setItem(TS, String(Date.now()));
      return p;
    }
  } catch (_) {}
  return null;
}

// Returns the visitor id only while the tryout window is active (so app usage isn't tracked forever).
function activeVisitorId() {
  const id = localStorage.getItem(KEY);
  const ts = Number(localStorage.getItem(TS) || 0);
  if (id && ts && Date.now() - ts < WINDOW_MS) return id;
  return null;
}

function post(event, meta, visitor_id) {
  if (!visitor_id) return;
  axios.post(`${API}/pmf/event`, { visitor_id, event, meta: meta || {} }).catch(() => {});
}

// Survey page events (always fire with the current id).
export function trackEvent(event, meta = {}) {
  post(event, meta, localStorage.getItem(KEY));
}

// In-app events — fire only for visitors actively in a survey tryout.
export function trackAppEvent(event, meta = {}) {
  post(event, meta, activeVisitorId());
}

export function saveResponse(payload) {
  const visitor_id = ensureVisitorId();
  return axios.post(`${API}/pmf/response`, { visitor_id, ...payload }).catch(() => {});
}
